export function isLogbookEntryEditWorkflowComplete({
  date,
  entryType,
  responsibleComplete,
  row4VariantComplete,
  timeComplete,
  pauseComplete,
  hoursComplete,
  keywordsComplete,
  dayServiceCodeComplete,
}) {
  return Boolean(
    date
      && entryType
      && responsibleComplete
      && row4VariantComplete
      && timeComplete
      && pauseComplete
      && hoursComplete
      && keywordsComplete
      && dayServiceCodeComplete,
  );
}

export function getAvailableDayServiceCodeGroups(entryTypeMeta = {}, row4Mode = '') {
  const supportsA3Za3 = Boolean(entryTypeMeta?.supportsA3Za3 ?? row4Mode === 'a3-za3');
  const supportsTGroup = Boolean(entryTypeMeta?.supportsTGroup ?? row4Mode === 'te1-flex-honorar');
  const supportsHonorar = Boolean(entryTypeMeta?.supportsHonorar ?? false);

  return [
    supportsA3Za3 ? 'A' : null,
    supportsTGroup ? 'T' : null,
    supportsHonorar ? 'HONORAR' : null,
  ].filter(Boolean);
}

export function resolveDayServiceVariant(codeGroup, serviceMode) {
  const flex = serviceMode === 'individual';
  if (codeGroup === 'A') return flex ? 'za3' : 'a3';
  if (codeGroup === 'T') return flex ? 'te1te2-flex' : 'te1te2';
  if (codeGroup === 'HONORAR') return flex ? 'honorar-flex' : 'honorar';
  return '';
}
